/* TODO, link definitions, files are hand-copied */

export const MESSAGE_CACHEFIRST_TYPE = 'ADDROUTE_CACHEFIRST';

export interface IMessageCacheFirstPayload {
    type: string;
    payload: {
        matcher: string;
        maxAge: number;
        maxEntries: number;
        cacheName: string;
        ignoreSearch?: boolean;
    };
}

export const MESSAGE_HEADERAPPEND_TYPE = 'ADDROUTE_HEADERAPPEND';

export interface IMessageHeaderAppendResponderPayload {
    type: string;
    payload: {
        matcher: string;
        key: string;
        val: string;
        expiration: number;
    };
}

export const MESSAGE_CACHEOAUTH_TYPE = 'ADDROUTE_CACHEOAUTHTOKEN';

export interface IMessageOAuthTokenPayload {
    type: string;
    payload: {
        pathSuffix: string;
    };
}

export const MESSAGE_PRECACHE_TYPE = 'ADDROUTE_PRECACHE';

export interface IMessagePreCachePayload {
    type: string;
    payload: {
        paths: string[];
    };
}

export const MESSAGE_ZIPRELATIVEPATH_TYPE = 'ADDROUTE_ZIPRELATIVEPATH';

export interface IMessageZipRelativePathResponderPayload {
    type: string;
    payload: {
        zipPath: string;
        relativeRespondPath: string;
    };
}

export const MESSAGE_TESTMESSAGE_TYPE = 'ADDROUTE_TESTMESSAGE';

export interface IMessageTest {
    type: string;
    payload: {
        message: string;
    };
}
